import { render } from "./RequestAccess.vue?vue&type=template&id=0aadae92&scoped=true&bindings={\"firstName\":\"setup\",\"lastName\":\"setup\",\"email\":\"setup\",\"submitRequest\":\"setup\",\"cancelRequest\":\"setup\",\"submissionTriggered\":\"setup\",\"showFirstNameError\":\"setup\",\"showLastNameError\":\"setup\",\"showEmailError\":\"setup\",\"state\":\"setup\",\"successfulSubmission\":\"setup\"}"
import script from "./RequestAccess.vue?vue&type=script&lang=ts"
export * from "./RequestAccess.vue?vue&type=script&lang=ts"

import "./RequestAccess.vue?vue&type=style&index=0&id=0aadae92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0aadae92"

export default script